import axios from 'axios'

import { ImageTemplate } from '@/clients/utoniq-core/schema'
import { config } from '@/config'

// 画像合成サービスAbyssaleのAPIを利用したモジュール

const headers = {
  'Content-Type': 'application/json',
  'x-api-key': config.abyssaleApiKey,
}

/**
 * @description compositeImage
 * imageTemplateの情報で画像を作成する
 *
 * @param {ImageTemplate} imageTemplate 画像テンプレートの情報
 * @param {File} file ファイルオブジェクト、これがある場合はbase64にエンコードしたデータを画像として送信する
 * @returns {Promise<string>} url 生成された画像のurl
 *
 * cf https://developers.abyssale.com/#generate-image
 */

export async function compositeImage(
  imageTemplate: ImageTemplate,
  file?: File
): Promise<string> {
  const payload = await convertOverrideValuesToInput(imageTemplate, file)

  return axios
    .post(
      `https://api.abyssale.com/banner-builder/${imageTemplate.templateId}/generate`,
      payload,
      { headers }
    )
    .then(response => response.data.image.url)
}

/**
 * @description convertOverrideValuesToInput
 * imageTemplateのデータをAbyssaleのリクエストパラメータに変換する
 *
 * @param imageTemplate Firestoreに定義されているテンプレートデータ
 * @param file (optional) アップロードしたファイル画像
 */
async function convertOverrideValuesToInput(
  imageTemplate: ImageTemplate,
  file?: File
) {
  const elements: {
    [elementName: string]: AbyssaleGenerateImageElement
  } = {}

  const image_encoded = file
    ? ((await convertFileToBase64(file)) as string)
    : ''

  Object.entries(imageTemplate.overrideElements).forEach(([_, data]) => {
    switch (data.type) {
      case 'text': {
        const element = {
          payload: data.value ?? '',
        }

        elements[data.elementName] = element
        break
      }
      case 'image': {
        const element = file
          ? { image_encoded }
          : { image_url: data.value ?? '' }
        elements[data.elementName] = element
        break
      }
    }
  })

  return {
    template_format_name: imageTemplate.templateFormatName || '',
    elements,
  }
}

type AbyssaleGenerateImageElement =
  | {
      image_url?: string
      image_encoded?: string
    }
  | {
      payload: string
    }

// file形式の画像をbase64に変換する
function convertFileToBase64(file: File) {
  return new Promise(resolve => {
    const reader = new FileReader()
    reader.readAsDataURL(file)

    reader.onload = () => {
      const base64 = reader.result
      resolve(
        typeof base64 === 'string' ? base64.replace('data:', 'data:image/') : ''
      )
    }
  })
}
